module.exports = require("dependency-graph");